<template>
  <div class="data">
    <span class="title">{{ topValuesLabel }}</span>
    <div class="name" v-for="(value, index) in topValues"
         :key="topValueName(value)"
         :style="opacity(index)"
    >
      {{ topValueName(value) }}
    </div>
    <div class="data-total">
      <div class="title">
        {{ totalLabel }}
      </div>
      <div class="count">
        {{ total }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TopIndicator',
  props: {
    total: {
      type: Number,
      default: 0
    },
    totalLabel: {
      type: String,
      required: true
    },
    topValues: {
      type: Array,
      default: () => []
    },
    topValueName: {
      type: Function,
      default: v => v
    },
    topValuesLabel: {
      type: String,
      required: true
    }
  },
  methods: {
    opacity(index) {
      let opacity = 1 - (index - 1) * 0.1
      return 'color: rgba(0, 125, 143, ' + opacity + ' );'
    }
  }
}
</script>

<style scoped lang="scss">
.data {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.data-total {
  margin-top: 36px;
}

.title {
  text-transform: capitalize;
  font-weight: 700;
  font-size: 18px;
}

.name {
  text-transform: uppercase;
  color: rgba(0, 125, 143, 0.9);
  font-weight: 600;
  margin-top: 18px;
}

.count {
  font-size: 50px;
}

</style>
